// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__3KF7Q","lastItem":"style_lastItem__DcHue"};